import React, { useState } from "react";
import { Popup, Icon, Checkbox, Input } from "semantic-ui-react";
import "./SitesMultiSelect.scss";

// Selector de sitios: en vez del dropdown con chips (se ve mal con muchos
// sitios elegidos — se aplastan o crecen a varias filas), un disparador
// compacto de una sola línea que abre un popup con checkboxes por sitio.
export function SitesMultiSelect({ sites, value, onChange, error, t }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const selected = value || [];
  const selectedSet = new Set(selected);

  const toggle = (id) => {
    if (selectedSet.has(id)) {
      onChange(selected.filter((v) => v !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  const label =
    selected.length === 0
      ? t("select")
      : `${selected.length} ${selected.length === 1 ? t("site") : t("sites") || "sitios"}`;

  const filteredSites = sites.filter((s) =>
    s.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Popup
      on="click"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      position="bottom left"
      className="sites-multiselect-popup"
      trigger={
        <div className={`sites-multiselect-trigger${error ? " error" : ""}`}>
          <span>{label}</span>
          <Icon name={open ? "chevron up" : "chevron down"} />
        </div>
      }
    >
      <div className="sites-multiselect-search">
        <Input
          icon="search"
          placeholder={t("search") || "Buscar..."}
          value={search}
          onChange={(_, d) => setSearch(d.value)}
          fluid
        />
      </div>
      <div className="sites-multiselect-list">
        {filteredSites.length === 0 ? (
          <div className="sites-multiselect-empty">
            {t("no_results_found") || "Sin resultados"}
          </div>
        ) : (
          filteredSites.map((s) => (
            <div key={s._id} className="sites-multiselect-item">
              <Checkbox
                label={s.name}
                checked={selectedSet.has(s._id)}
                onChange={() => toggle(s._id)}
              />
            </div>
          ))
        )}
      </div>
    </Popup>
  );
}
